import React from 'react';
import coverbackground from '../../assets/land-bg.jpg';
import ReusableScrollCard from '../../components/ReusableScrollcard/ReusableScrollcard';

class ScrollLand extends React.Component {
  render () { 
   return(
  
  <ReusableScrollCard             
    
        tag="EXPLORE"
        description="Land"
        coverbackground={coverbackground}
     />
  
  );
 }
}   

export default ScrollLand;